import Users from '@/views/admin/users'
import UserSave from '@/views/admin/users/Save'
import UserAssociate from '@/views/admin/users/Associate'

export const users = [
  {
    path: 'users/list',
    component: Users,
    meta: {
      requiresAuth: true,
      adminAuth: true
    }
  },
  {
    name: 'admin_users_save',
    path: 'users/save/:id?/:name?',
    component: UserSave,
    meta: {
      requiresAuth: true,
      adminAuth: true
    }
  },
  {
    path: 'users/associate',
    component: UserAssociate,
    meta: {
      requiresAuth: true,
      adminAuth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/admin/user.js